import { FC, useLayoutEffect } from 'react';
import { Outlet } from 'react-router-dom';

import HorizontalTabs from 'components/HorizontalTabs';

import Alert from 'primitives/Alert';

import commitmentsIcons from 'media/icons/commitments.svg';
import invitesIcons from 'media/icons/invites.svg';
import passedInvitesIcon from 'media/icons/passed-invites.svg';

import { useInvestPageNav } from '../InvestPage/InvestPageNavContext';
import { INVEST_HUB_DEAL_INVITES_PATH } from '../InvestPage/investHubPaths';

const DealInvites: FC = () => {
  const { setNavMeta } = useInvestPageNav();

  useLayoutEffect(() => {
    setNavMeta({
      subTitle: 'Investment opportunities delivered directly to your inbox.',
      onBackButtonClick: undefined,
    });
  }, [setNavMeta]);

  const tabs = [
    {
      key: 'active',
      label: 'Invited',
      description: '',
      route: INVEST_HUB_DEAL_INVITES_PATH,
      icon: invitesIcons,
      exact: true,
    },
    {
      key: 'committed',
      label: 'Committed',
      description: '',
      route: `${INVEST_HUB_DEAL_INVITES_PATH}/committed`,
      icon: commitmentsIcons,
    },
    {
      key: 'passed',
      label: 'Passed',
      description: '',
      route: `${INVEST_HUB_DEAL_INVITES_PATH}/passed`,
      icon: passedInvitesIcon,
    },
  ];

  return (
    <>
      <div>
        <Alert
          type="warning"
          title="Confidential: Disclosing deal information will result in removal from AngelList India"
          className="mb-4"
        />
        <nav className="mb-4 border-b border-slate-100 pb-3">
          <HorizontalTabs tabs={tabs} />
        </nav>
        <Outlet />
      </div>
    </>
  );
};

export default DealInvites;
